import { render, staticRenderFns } from "./CareProtocolTemplates.vue?vue&type=template&id=180217ea&"
import script from "./CareProtocolTemplates.vue?vue&type=script&lang=js&"
export * from "./CareProtocolTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports